import React from "react";
import { Helmet } from "react-helmet";
// import FarmersSection from "./FarmersSection";
import Footer from "../../components/common/Footer";
import ProductShowcase from "../../components/common/ProductShowcase";
import ProductsSection from "../UtpannProduction/ProductsSection";
import TestimonialPage from "../PressReleaseGallery/TestimonialSection";

const ProductDetails5 = () => {
  const utpannProData = {
    title: "Utpann PRO",
    category: "Bio Stimulant",
    image: "/assets/Product/img5.png",
    description:
      "UTPANN Pro enhances flowering and ensures better flower retention for higher fruit set. It supports uniform fruit development, improving fruit size, quality, and overall yield.",
    price: "999",
    priceNote: "Per 1 ltr Bottle (Gujarat) (Inc GST)",
    recommendations: [
      "Flowering",
      "Increase Fruit Size & Yield",
      "Better Fruit Set",
    ],
    // Utpann PRO image mein technical specs section nahi hai, isliye ise empty rakha hai ya aap skip kar sakte hain
    specsTitle: "",
    specs: [],
    packaging: [
      { label: "Bulk Bags", value: "1000ltr IBC" },
      { label: "Standard Pack", value: "1ltr" },
      { label: "Tanker", value: "20kl & 40kl available" },
      { label: "Minimum Order", value: "1 metric ton" },
      { label: "Custom Packaging", value: "Available on request" },
    ],
    benefits: [
      "Promotes profuse flowering and reduces flower drop",
      "Improves fruit set and uniform fruit development",
      "Increases fruit size, weight, and overall quality",
      "Enhances total yield and crop profitability",
    ],
  };
  return (
    <>
      <Helmet>
        <title>
          Utpann Production - Organic Bio-Fertilizer & Kesari Phos Products |
          Gujarat
        </title>
        <meta
          name="description"
          content="Utpann Production offers premium organic bio-fertilizers including Kesari Phos variants. 50k+ annual volume, 15+ manufacturing partners serving sustainable farming across Gujarat, India."
        />
        <meta
          property="og:title"
          content="Utpann Production - Organic Bio-Fertilizer & Kesari Phos Products | Gujarat"
        />
        <meta
          property="og:description"
          content="Utpann Production offers premium organic bio-fertilizers including Kesari Phos variants. 50k+ annual volume, 15+ manufacturing partners serving sustainable farming across Gujarat, India."
        />
      </Helmet>

      <main>
        <ProductShowcase productData={utpannProData} />
        <div className="relative ">
          {/* Product Image Placeholder */}
          <img
            src="/assets/Product/Soil.png"
            alt={"Soil"}
            className="w-full h-auto object-contain"
          />
        </div>
        <ProductsSection />
        {/* <FarmersSection /> */}
        <TestimonialPage />
        <Footer />
      </main>
    </>
  );
};

export default ProductDetails5;
